module.exports = __webpack_public_path__ + "static/media/ec.1e33ff75.svg";